import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UmsatzabfrageState } from '../../../store/umsatzabfrage.store';
import { Item } from '../../../types/item';
import { UmsatzValueForIndexPipe } from '../../../pipes/umsatz-value-for-index.pipe';

import { DateInputComponent } from '@softline/ui-core/date-input';
import { SelectComponent, SelectOptionDirective, SelectOptionHeaderDirective, SelectOptionSeparatorDirective } from '@softline/ui-core/combo-box';
import { SortFunctionPipe } from '@softline/ui-core';
import { TabComponent } from '@softline/ui-core/tab-group';
import { TabGroupComponent } from '@softline/ui-core/tab-group';
import { TabTitleDirective } from '@softline/ui-core/tab-group';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-umsatzabfrage',
  imports: [ReactiveFormsModule, CommonModule, UmsatzValueForIndexPipe,
    DateInputComponent,
    SelectComponent,
    SelectOptionDirective,
    TabComponent,
    TabGroupComponent,
    TranslatePipe,
    SortFunctionPipe],
  templateUrl: './umsatzabfrage.html',
  changeDetection: ChangeDetectionStrategy.OnPush })
export class Umsatzabfrage {
  data = input.required<
    | {
        date: string;
        current: any;
        vergleich: any;
      }[]
    | null
  >();
  umsatzabfrageFilialen = input.required<UmsatzabfrageState['filialen'] | null>();
  item = input.required<Item | null>();
  selectedUmsatzabfrageViewIndex = input.required<number | null>();
  sum = input.required<{
    sum:
      | {
          current: any;
          vergleich: any;
        }
      | undefined;
    ekSum:
      | {
          current: any;
          vergleich: any;
        }
      | undefined;
  } | null>();
  umsatzabfrageForm = input.required<
    FormGroup<{
      from: FormControl<string | null>;
      to: FormControl<string | null>;
      filiale: FormControl<string | null>;
    }>
  >();

  formSubmit = output();
  tabIndexChanged = output<{ index: number; item: Item }>();

  onSubmit() {
    this.formSubmit.emit();
  }

  onTabIndexChanged($event, item: Item) {
    this.tabIndexChanged.emit({ index: $event, item: item });
  }

  sortByDate(a: any, b: any): number {
    return a?.date > b?.date ? 1 : -1;
  }
}
